import { slicedToArray as _slicedToArray, createForOfIteratorHelper as _createForOfIteratorHelper, createClass as _createClass, classCallCheck as _classCallCheck } from '../../../_virtual/_rollupPluginBabelHelpers.js';

/* adapted from the venerable Modernizr */
var el = typeof document === 'undefined' ? undefined : document.createElement('fakeelement');
/** Represents a CSS object name / event name pair, used for in-browser feature detection */

var TransitionNamePair = /*#__PURE__*/function () {
  function TransitionNamePair(cssObjectName, eventName) {
    _classCallCheck(this, TransitionNamePair);

    this.cssObjectName = cssObjectName;
    this.eventName = eventName;
  }

  _createClass(TransitionNamePair, [{
    key: "exists",
    get: function get() {
      if (el) return el.style.getPropertyValue(this.cssObjectName) !== undefined;
      return false;
    }
  }]);

  return TransitionNamePair;
}();
/** Machinery to obtain a working transitionend event name!
 *  decides which transitionend event name is needed in the current browser */


function transitionEventNameTester() {
  /** The list of possible CSS object name / event name pairs */
  var possibleNames = [['transition', 'transitionend'], ['OTransition', 'oTransitionEnd'], ['MozTransition', 'transitionend'], ['WebkitTransition', 'webkitTransitionEnd']].map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        c = _ref2[0],
        e = _ref2[1];

    return new TransitionNamePair(c, e);
  });
  /** Note the W3C standard one */

  var standard = possibleNames[0];
  /** Returns the transitionend event name that works */

  var _iterator = _createForOfIteratorHelper(possibleNames),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var n = _step.value;
      if (n.exists) return n.eventName;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return standard.eventName; // fallback for correctness
}
/** The name for the W3C standard 'transitionend' event -- may be non-standard in old browsers */


var transitionEndEventName = transitionEventNameTester();

export { transitionEndEventName };
